import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הקנאה בלי להיבהל",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להיות “מעל זה”. אני מזהה את הקנאה — ונשאר איתי.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני לא מנסה להיות “מעל זה”. אני מזהה את הקנאה — ונשאר איתי.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “זה כאב וקנאה. הם לא פקודה.”"
    ],
      [
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “זה כאב וקנאה. הם לא פקודה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה — בשבילי\nאני שואל את עצמי:\nמה אני מרגיש עכשיו כשעולה התמונה/המחשבה על האקס/ית עם מישהו/י אחר/ת? (מילה או שתיים)",
      "אני שואל את עצמי:\nאיפה בגוף אני מרגיש את זה? (חזה/בטן/גרון/ראש)",
      "אני שואל את עצמי:\nמה הדבר שהכי “שורף” לי בתוך זה? (החלפה? דחייה? השוואה? פחד?)"
    ],
      [
      "כתיבה — בשבילי\nאני שואל את עצמי:\nמה אני מרגיש עכשיו כשעולה התמונה/המחשבה על האקס/ית עם מישהו/י אחר/ת? (מילה או שתיים)",
      "אני שואל את עצמי:\nאיפה בגוף אני מרגיש את זה? (חזה/בטן/גרון/ראש)",
      "אני שואל את עצמי:\nמה הדבר שהכי “שורף” לי בתוך זה? (החלפה? דחייה? השוואה? פחד?)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "היום אני לא מתווכח עם הרגש. אני רואה אותו ונושם לידו."
    ],
      [
      "סגירה",
      "היום אני לא מתווכח עם הרגש. אני רואה אותו ונושם לידו."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה טריגר — אני עושה “עצירת 30 שניות”: נשימה אחת + משפט בלב: “זה גל. הוא עובר.”",
      "כשעולה טריגר — אני עושה “עצירת 30 שניות”: נשימה אחת + משפט בלב: “זה גל. הוא עובר.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "סיפור מול עובדה (להפסיק לחיות בסרט)",
    opening: localizedGenderNode(
      [
      "היום אני מפריד בין מה שאני יודע לבין מה שהמוח מצייר.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מפריד בין מה שאני יודע לבין מה שהמוח מצייר.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אני לא רוצה להאמין לכל תמונה.”"
    ],
      [
      "נשימה אחת. “אני לא רוצה להאמין לכל תמונה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה העובדה היבשה שאני יודע/ת? (2 שורות, בלי פרשנות)",
      "איזה סרט הראש שלי בונה סביב זה? (מה אני מדמיין/ת שזה אומר?)",
      "מה זה עושה לי בגוף כשאני מאמין/ה לסרט הזה — ואיזו אמת עדינה אחת אני יכול/ה לבחור היום במקום הסרט? (משפט אחד)"
    ],
      [
      "כתיבה\nמה העובדה היבשה שאני יודע/ת? (2 שורות, בלי פרשנות)",
      "איזה סרט הראש שלי בונה סביב זה? (מה אני מדמיין/ת שזה אומר?)",
      "מה זה עושה לי בגוף כשאני מאמין/ה לסרט הזה — ואיזו אמת עדינה אחת אני יכול/ה לבחור היום במקום הסרט? (משפט אחד)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לא כל מחשבה היא אמת. לפעמים זו רק חרדה שמבקשת שליטה."
    ],
      [
      "סגירה",
      "לא כל מחשבה היא אמת. לפעמים זו רק חרדה שמבקשת שליטה."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום אני אומר/ת: “זה סיפור. אני חוזר/ת לעובדות.” ואז נשימה אחת.",
      "פעם אחת היום אני אומר/ת: “זה סיפור. אני חוזר/ת לעובדות.” ואז נשימה אחת."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "דחף לבדוק/להציץ (פרוטוקול 90 שניות)",
    opening: localizedGenderNode(
      [
      "היום אני בונה עצירה לפני פעולה, כדי שהקנאה לא תנהל אותי.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני בונה עצירה לפני פעולה, כדי שהקנאה לא תנהל אותי.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אני בוחר/ת בי קודם.”"
    ],
      [
      "נשימה אחת. “אני בוחר/ת בי קודם.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיזה דחף עולה לי היום? (להציץ/לבדוק/לחפש/לשלוח)",
      "מה אני באמת מנסה להרגיע דרך הדחף הזה? (חוסר ודאות? כאב? פחד נטישה? השפלה?)",
      "פרוטוקול 90 שניות (קבוע מהיום)\n\n1. 3 נשימות איטיות\n\n\n2. לשים לב לגוף: איפה הדחף יושב\n\n\n3. משפט בלב: “זה דחף. הוא יעבור.”\nואז לבחור חלופה אחת קטנה.\n\n\n\nאיזו חלופה אחת אני בוחר/ת היום במקום לבדוק?"
    ],
      [
      "כתיבה\nאיזה דחף עולה לי היום? (להציץ/לבדוק/לחפש/לשלוח)",
      "מה אני באמת מנסה להרגיע דרך הדחף הזה? (חוסר ודאות? כאב? פחד נטישה? השפלה?)",
      "פרוטוקול 90 שניות (קבוע מהיום)\n\n1. 3 נשימות איטיות\n\n\n2. לשים לב לגוף: איפה הדחף יושב\n\n\n3. משפט בלב: “זה דחף. הוא יעבור.”\nואז לבחור חלופה אחת קטנה.\n\n\n\nאיזו חלופה אחת אני בוחר/ת היום במקום לבדוק?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת לפעול כדי להירגע. אני יכול/ה להירגע גם בלי פעולה."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת לפעול כדי להירגע. אני יכול/ה להירגע גם בלי פעולה."
    ]
    ),
    action: localizedGenderNode(
      "בכל פעם שעולה דחף — אני עושה את פרוטוקול 90 שניות פעם אחת בלבד.",
      "בכל פעם שעולה דחף — אני עושה את פרוטוקול 90 שניות פעם אחת בלבד."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "ההשוואה (להחזיר ערך עצמי)",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה למדוד את עצמי מול מישהו/י אחר/ת.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מפסיק/ה למדוד את עצמי מול מישהו/י אחר/ת.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “השוואה היא כאב בתחפושת של אמת.”"
    ],
      [
      "נשימה אחת. “השוואה היא כאב בתחפושת של אמת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הדבר שאני משווה בו? (יופי/גיל/כסף/קלילות/ביטחון/מעמד)",
      "מה אני אומר/ת לעצמי שזה אומר עליי?",
      "איזו אמת אחרת קיימת עליי, גם אם אני לא מרגיש/ה אותה עכשיו? (משפט אחד) — ואיזה כוח/ערך אחד בי לא תלוי באף אחד?"
    ],
      [
      "כתיבה\nמה הדבר שאני משווה בו? (יופי/גיל/כסף/קלילות/ביטחון/מעמד)",
      "מה אני אומר/ת לעצמי שזה אומר עליי?",
      "איזו אמת אחרת קיימת עליי, גם אם אני לא מרגיש/ה אותה עכשיו? (משפט אחד) — ואיזה כוח/ערך אחד בי לא תלוי באף אחד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הערך שלי לא נעלם כי מישהו/י אחר/ת הופיע/ה."
    ],
      [
      "סגירה",
      "הערך שלי לא נעלם כי מישהו/י אחר/ת הופיע/ה."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת 3 תכונות/ערכים שהם שלי בלבד — ושומר/ת אותם ביומן.",
      "אני כותב/ת 3 תכונות/ערכים שהם שלי בלבד — ושומר/ת אותם ביומן."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הבושה (התחושה ש”החליפו אותי”)",
    opening: localizedGenderNode(
      [
      "היום אני נוגע בבושה בלי לתת לה לפרק אותי.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני נוגע בבושה בלי לתת לה לפרק אותי.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “בושה רוצה שאסתתר. היום אני נשאר/ת.”"
    ],
      [
      "נשימה אחת. “בושה רוצה שאסתתר. היום אני נשאר/ת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה המשפט הכי קשה לי לשמוע בתוך הראש? (“לא הייתי מספיק…”, “החליפו אותי…”)",
      "אם חבר שאני אוהב היה אומר את זה על עצמו — מה הייתי אומר לו?",
      "מה משפט רך אחד שאני מוכן/ה להגיד לעצמי היום במקום הבושה — ומה אני בוחר/ת עכשיו כדי להרגיש קצת מוגן/ת?"
    ],
      [
      "כתיבה\nמה המשפט הכי קשה לי לשמוע בתוך הראש? (“לא הייתי מספיק…”, “החליפו אותי…”)",
      "אם חבר שאני אוהב היה אומר את זה על עצמו — מה הייתי אומר לו?",
      "מה משפט רך אחד שאני מוכן/ה להגיד לעצמי היום במקום הבושה — ומה אני בוחר/ת עכשיו כדי להרגיש קצת מוגן/ת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בושה לא אומרת אמת. היא אומרת שכואב לי."
    ],
      [
      "סגירה",
      "בושה לא אומרת אמת. היא אומרת שכואב לי."
    ]
    ),
    action: localizedGenderNode(
      "כשעולה בושה — יד על חזה/בטן (אם נעים) + משפט רך אחד בלבד.",
      "כשעולה בושה — יד על חזה/בטן (אם נעים) + משפט רך אחד בלבד."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "קנאה ככאב של קשר (מה חסר לי עכשיו)",
    opening: localizedGenderNode(
      [
      "היום אני מבין/ה שקנאה מצביעה על צורך.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מבין/ה שקנאה מצביעה על צורך.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “קנאה היא חץ שמצביע על מקום ריק.”"
    ],
      [
      "נשימה אחת. “קנאה היא חץ שמצביע על מקום ריק.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה חסר לי עכשיו באמת? (חום? שייכות? ביטחון? אישור? מגע? עתיד?)",
      "איך הייתי רוצה לקבל את זה — בגרסה נקייה שלא פוגעת בי?",
      "מי/מה יכול לתת לי חלק מזה היום? (אדם בטוח/פעולה/שגרה) — ומה צעד אחד קטן שאני עושה היום כדי למלא צורך אחד?"
    ],
      [
      "כתיבה\nמה חסר לי עכשיו באמת? (חום? שייכות? ביטחון? אישור? מגע? עתיד?)",
      "איך הייתי רוצה לקבל את זה — בגרסה נקייה שלא פוגעת בי?",
      "מי/מה יכול לתת לי חלק מזה היום? (אדם בטוח/פעולה/שגרה) — ומה צעד אחד קטן שאני עושה היום כדי למלא צורך אחד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הקנאה לא רוצהת להוביל לפעולה כלפי האקס/ית. היא יכולה להוביל אליי."
    ],
      [
      "סגירה",
      "הקנאה לא רוצהת להוביל לפעולה כלפי האקס/ית. היא יכולה להוביל אליי."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת “חיבור נקי” אחד: שיחה קצרה עם אדם בטוח / הליכה / מוזיקה שקטה.",
      "אני בוחר/ת “חיבור נקי” אחד: שיחה קצרה עם אדם בטוח / הליכה / מוזיקה שקטה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "חשיפה נקייה (ACT עדין) — לשאת תמונה בלי לברוח",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת לשאת טריגר רגע, בלי לבדוק ובלי להישאב.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מתרגל/ת לשאת טריגר רגע, בלי לבדוק ובלי להישאב.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אני יכול/ה להיות עם זה דקה.”"
    ],
      [
      "נשימה אחת. “אני יכול/ה להיות עם זה דקה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיזה טריגר הכי מפעיל אותי? (תמונה/מקום/רשתות/שיר/סצנה)",
      "אני בוחר/ת תרגול חשיפה נקייה:\nדקה אחת — אני נותן/ת לתמונה להיות בראש, בלי פעולה. רק נשימה.\n\nמה קרה אחרי הדקה? (בגוף/במחשבות)",
      "מה למדתי על הגל? (האם הוא באמת “לא עובר”? )"
    ],
      [
      "כתיבה\nאיזה טריגר הכי מפעיל אותי? (תמונה/מקום/רשתות/שיר/סצנה)",
      "אני בוחר/ת תרגול חשיפה נקייה:\nדקה אחת — אני נותן/ת לתמונה להיות בראש, בלי פעולה. רק נשימה.\n\nמה קרה אחרי הדקה? (בגוף/במחשבות)",
      "מה למדתי על הגל? (האם הוא באמת “לא עובר”? )"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני מתחזק/ת לא כי ברחתי — אלא כי נשארתי."
    ],
      [
      "סגירה",
      "אני מתחזק/ת לא כי ברחתי — אלא כי נשארתי."
    ]
    ),
    action: localizedGenderNode(
      "תרגול דקה אחת בלבד. לא יותר. עקביות > כוח.",
      "תרגול דקה אחת בלבד. לא יותר. עקביות > כוח."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבולות רכים (להגן על הלב)",
    opening: localizedGenderNode(
      [
      "היום אני שם גבול קטן שמגן עליי, בלי מלחמה.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני שם גבול קטן שמגן עליי, בלי מלחמה.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “גבול הוא שמירה, לא עונש.”"
    ],
      [
      "נשימה אחת. “גבול הוא שמירה, לא עונש.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיזה גבול אחד יעזור לי השבוע? (לא לבדוק רשתות / לא לשאול חברים / לא לחפש מידע)",
      "מה הפחד שלי אם אני שם את הגבול הזה?",
      "מה תשובה רכה לפחד הזה — ואיך אני מנסח/ת את הגבול בגוף ראשון? (“השבוע אני לא _ כדי להגן עליי”)"
    ],
      [
      "כתיבה\nאיזה גבול אחד יעזור לי השבוע? (לא לבדוק רשתות / לא לשאול חברים / לא לחפש מידע)",
      "מה הפחד שלי אם אני שם את הגבול הזה?",
      "מה תשובה רכה לפחד הזה — ואיך אני מנסח/ת את הגבול בגוף ראשון? (“השבוע אני לא _ כדי להגן עליי”)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "גבול שומר על לב פצוע. זה מעשה של כבוד עצמי."
    ],
      [
      "סגירה",
      "גבול שומר על לב פצוע. זה מעשה של כבוד עצמי."
    ]
    ),
    action: localizedGenderNode(
      "אני מפעיל/ה פעולה אחת שמקלה על הגבול: הסתרה/השתקה/מחיקה של טריגר אחד.",
      "אני מפעיל/ה פעולה אחת שמקלה על הגבול: הסתרה/השתקה/מחיקה של טריגר אחד."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "“הם מאושרים ואני נשארתי” (לשבור את המיתוס)",
    opening: localizedGenderNode(
      [
      "היום אני מפסיק/ה לקרוא חיים של אחרים מתוך תמונה אחת.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מפסיק/ה לקרוא חיים של אחרים מתוך תמונה אחת.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אני לא יודע/ת את כל הסיפור שלהם.”"
    ],
      [
      "נשימה אחת. “אני לא יודע/ת את כל הסיפור שלהם.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nאיזה משפט אוטומטי עולה לי? (“הם מאושרים”, “אני נזרקתי”, “אני פחות”)",
      "מה אני באמת יודע/ת, ומה אני רק מנחש/ת?",
      "מה הדבר שאני כן יכול/ה לבנות בשבילי, גם אם כואב — ואיזו אמת אחת על הדרך שלי אני מוכן/ה לזכור היום?"
    ],
      [
      "כתיבה\nאיזה משפט אוטומטי עולה לי? (“הם מאושרים”, “אני נזרקתי”, “אני פחות”)",
      "מה אני באמת יודע/ת, ומה אני רק מנחש/ת?",
      "מה הדבר שאני כן יכול/ה לבנות בשבילי, גם אם כואב — ואיזו אמת אחת על הדרך שלי אני מוכן/ה לזכור היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "התמונה שלהם לא מגדירה את הערך שלי, ולא את העתיד שלי."
    ],
      [
      "סגירה",
      "התמונה שלהם לא מגדירה את הערך שלי, ולא את העתיד שלי."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום — אני מחליף/ה את המשפט האוטומטי במשפט אמת אחד (מה שכתבתי).",
      "פעם אחת היום — אני מחליף/ה את המשפט האוטומטי במשפט אמת אחד (מה שכתבתי)."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "הכעס (להוציא אותו בלי להרוס)",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לכעס לצאת בדרך שמכבדת אותי.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני נותן/ת לכעס לצאת בדרך שמכבדת אותי.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “מותר לי לכעוס. אסור לי לפגוע בעצמי.”"
    ],
      [
      "נשימה אחת. “מותר לי לכעוס. אסור לי לפגוע בעצמי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nעל מה הכעס שלי באמת?",
      "איזה גבול או ערך הכעס הזה בא להחזיר? (כבוד/אמת/נאמנות/ביטחון)",
      "איך אני מוציא/ה כעס בלי לבדוק/לתקוף/להשפיל את עצמי? (פעולה גופנית/כתיבה) — ומה פעולה אחת של כבוד עצמי אני עושה היום מתוך הכעס?"
    ],
      [
      "כתיבה\nעל מה הכעס שלי באמת?",
      "איזה גבול או ערך הכעס הזה בא להחזיר? (כבוד/אמת/נאמנות/ביטחון)",
      "איך אני מוציא/ה כעס בלי לבדוק/לתקוף/להשפיל את עצמי? (פעולה גופנית/כתיבה) — ומה פעולה אחת של כבוד עצמי אני עושה היום מתוך הכעס?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כעס יכול להפוך לכוח שמסדר אותי, לא לכוח שמפרק אותי."
    ],
      [
      "סגירה",
      "כעס יכול להפוך לכוח שמסדר אותי, לא לכוח שמפרק אותי."
    ]
    ),
    action: localizedGenderNode(
      "10 דקות תנועה (הליכה מהירה/ספורט קל) — כדי להוציא אנרגיה מהגוף.",
      "10 דקות תנועה (הליכה מהירה/ספורט קל) — כדי להוציא אנרגיה מהגוף."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "להחזיר שליטה (שלושה דברים שכן בידיים שלי)",
    opening: localizedGenderNode(
      [
      "היום אני מצמצם כאוס לצעד קטן.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני מצמצם כאוס לצעד קטן.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “צעד אחד מספיק.”"
    ],
      [
      "נשימה אחת. “צעד אחד מספיק.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הכי מציף אותי היום סביב זה?",
      "מה 3 דברים שכן בשליטתי היום? (קטנים מאוד)",
      "איזה צעד אחד בלבד אני עושה היום — ומה דבר אחד אני משחרר/ת היום, אפילו קצת?"
    ],
      [
      "כתיבה\nמה הכי מציף אותי היום סביב זה?",
      "מה 3 דברים שכן בשליטתי היום? (קטנים מאוד)",
      "איזה צעד אחד בלבד אני עושה היום — ומה דבר אחד אני משחרר/ת היום, אפילו קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה"
    ],
      [
      "סגירה"
    ]
    ),
    action: localizedGenderNode(
      "פעולה קטנה להיום",
      "פעולה קטנה להיום"
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "הלילה והלופים (סיום פרק)",
    opening: localizedGenderNode(
      [
      "היום אני נותן למוח “סגירת יום” כדי לנוח.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני נותן למוח “סגירת יום” כדי לנוח.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “הלילה אני לא רוצה/ת לפתור.”"
    ],
      [
      "נשימה אחת. “הלילה אני לא רוצה/ת לפתור.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הלופ הלילי הכי קבוע?",
      "מה הלופ מנסה להשיג בשבילי? (שליטה/תשובה/תקווה)",
      "איזה משפט סגירה ללילה אני בוחר/ת? (משפט אחד) — ואיזה טקס 3 דקות יעזור לי לפני שינה?"
    ],
      [
      "כתיבה\nמה הלופ הלילי הכי קבוע?",
      "מה הלופ מנסה להשיג בשבילי? (שליטה/תשובה/תקווה)",
      "איזה משפט סגירה ללילה אני בוחר/ת? (משפט אחד) — ואיזה טקס 3 דקות יעזור לי לפני שינה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מוח עייף מספר סיפורים חזקים. הלילה אני בוחר/ת מנוחה."
    ],
      [
      "סגירה",
      "מוח עייף מספר סיפורים חזקים. הלילה אני בוחר/ת מנוחה."
    ]
    ),
    action: localizedGenderNode(
      "לפני שינה: משפט הסגירה שלי + נשימה אחת. זה הכול.",
      "לפני שינה: משפט הסגירה שלי + נשימה אחת. זה הכול."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "להפוך קנאה לכיוון (מה אני בונה עכשיו)",
    opening: localizedGenderNode(
      [
      "היום הקנאה הופכת מצריבה — למצפן.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום הקנאה הופכת מצריבה — למצפן.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “מה שאני מרגיש/ה אומר לי מה חשוב לי.”"
    ],
      [
      "נשימה אחת. “מה שאני מרגיש/ה אומר לי מה חשוב לי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nמה הקנאה מגלה לי שאני רוצה בחיים שלי? (קשר? ביטחון? אהבה? בית?)",
      "איזה ערך אחד אני בוחר/ת להוביל אותי עכשיו? (כבוד/אמת/שקט/יציבות)",
      "איזה הרגל קטן מקרב אותי לערך הזה השבוע — ומה אני מבטיח/ה לעצמי כשיעלה טריגר חזק? (משפט אחד)"
    ],
      [
      "כתיבה\nמה הקנאה מגלה לי שאני רוצה בחיים שלי? (קשר? ביטחון? אהבה? בית?)",
      "איזה ערך אחד אני בוחר/ת להוביל אותי עכשיו? (כבוד/אמת/שקט/יציבות)",
      "איזה הרגל קטן מקרב אותי לערך הזה השבוע — ומה אני מבטיח/ה לעצמי כשיעלה טריגר חזק? (משפט אחד)"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת להישאר במקום של השוואה. אני יכול/ה לבנות חיים."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת להישאר במקום של השוואה. אני יכול/ה לבנות חיים."
    ]
    ),
    action: localizedGenderNode(
      "אני מתכנן/ת דבר אחד קטן לשבוע הקרוב שמחזיר לי עתיד (פגישה/שגרה/פרויקט).",
      "אני מתכנן/ת דבר אחד קטן לשבוע הקרוב שמחזיר לי עתיד (פגישה/שגרה/פרויקט)."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "טקס שחרור וסגירה (להישאר עם עצמי)",
    opening: localizedGenderNode(
      [
      "היום אני סוגר/ת פרק בלי למחוק אותו. אני מחזיר/ה את עצמי לעצמי.",
      "אני עוצר רגע עם עצמי."
    ],
      [
      "היום אני סוגר/ת פרק בלי למחוק אותו. אני מחזיר/ה את עצמי לעצמי.",
      "אני עוצר רגע עם עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת. “אני משחרר/ת בלי להיעלם.”"
    ],
      [
      "נשימה אחת. “אני משחרר/ת בלי להיעלם.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "כתיבה\nשלושה דברים שאני מפסיק/ה לעשות כדי להגן על הלב שלי:",
      "שלושה דברים שאני מתחיל/ה לעשות כדי לבנות אותי:",
      "מכתב קצר שלא נשלח (5 שורות) — מה אני רוצה להגיד ולשחרר; ומתחתיו משפט חזרה לימים קשים (משפט קצר, ברור):"
    ],
      [
      "כתיבה\nשלושה דברים שאני מפסיק/ה לעשות כדי להגן על הלב שלי:",
      "שלושה דברים שאני מתחיל/ה לעשות כדי לבנות אותי:",
      "מכתב קצר שלא נשלח (5 שורות) — מה אני רוצה להגיד ולשחרר; ומתחתיו משפט חזרה לימים קשים (משפט קצר, ברור):"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא מוחק/ת רגש.",
      "אני מפסיק/ה לתת לו לנהל אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא מוחק/ת רגש.",
      "אני מפסיק/ה לתת לו לנהל אותי.",
      "אני ממשיך/ה ללכת —",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת פעולה אחת שמסמלת “פרק חדש”: ניקוי קטן בבית / הליכה במקום חדש / סידור יומן שבועי.",
      "אני בוחר/ת פעולה אחת שמסמלת “פרק חדש”: ניקוי קטן בבית / הליכה במקום חדש / סידור יומן שבועי."
    ),
  },
].map(buildNormalizedDay);

export const jealousyExMovesOnBlueprintHe = buildNormalizedPilotBlueprint({
  id: "jealousy_ex_moves_on_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "jealousy_ex_moves_on",
  category: "general",
  journeyName: {
    he: "קנאה כשהאקס/ית ממשיכים הלאה",
    en: "Jealousy When an Ex Moves On",
    es: "Celos cuando el/la ex sigue adelante",
  },
  days,
});

export default jealousyExMovesOnBlueprintHe;
